import React from 'react';
import { Bot, CalendarCheck, FileUp, Plus, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Label } from '../ui/label';

const today = new Date().toISOString().slice(0, 10);
const monthStart = `${today.slice(0, 7)}-01`;

export const AccountingScopeBar = ({
  companies, accounts, fiscalYears, fiscalYear, companyId, accountId, dateFrom, dateTo, loading,
  onFiscalYearChange, onCompanyChange, onAccountChange, onDateFrom, onDateTo, onImport, onManual,
  onCloseMonth, onAi, onSync,
}) => {
  const companyAccounts = accounts.filter((a) => a.company_id === companyId);
  return (
    <Card className="p-4 border-slate-300 shadow-none" data-testid="scope-selector-bar">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-[1.1fr_1.1fr_0.65fr_0.75fr_0.75fr_auto] gap-3 items-end">
        <div>
          <Label htmlFor="accounting-company">Società / intestatario</Label>
          <select id="accounting-company" value={companyId} onChange={(e) => onCompanyChange(e.target.value)} className="mt-1 h-9 w-full rounded-md border bg-white px-3 text-sm" data-testid="company-scope-select">
            {companies.map((company) => <option key={company.id} value={company.id}>{company.name}</option>)}
          </select>
        </div>
        <div>
          <Label htmlFor="accounting-fiscal-year">Esercizio</Label>
          <select id="accounting-fiscal-year" value={fiscalYear} onChange={(e) => onFiscalYearChange(Number(e.target.value))} className="mt-1 h-9 w-full rounded-md border bg-white px-3 text-sm font-semibold" data-testid="fiscal-year-scope-select">
            {fiscalYears.map((year) => <option key={year.year} value={year.year}>{year.year} · {year.status === 'closed' ? 'Chiuso' : year.status === 'in_review' ? 'In verifica' : 'Aperto'}</option>)}
          </select>
        </div>
        <div>
          <Label htmlFor="accounting-account">Conto corrente</Label>
          <select id="accounting-account" value={accountId} onChange={(e) => onAccountChange(e.target.value)} className="mt-1 h-9 w-full rounded-md border bg-white px-3 text-sm" data-testid="account-scope-select">
            <option value="all">Tutti i conti autorizzati</option>
            {companyAccounts.map((account) => <option key={account.id} value={account.id}>{account.bank_name} · {account.account_name}</option>)}
          </select>
        </div>
        <div>
          <Label htmlFor="accounting-date-from">Dal</Label>
          <input id="accounting-date-from" type="date" min={`${fiscalYear}-01-01`} max={`${fiscalYear}-12-31`} value={dateFrom} onChange={(e) => onDateFrom(e.target.value)} className="mt-1 h-9 w-full rounded-md border bg-white px-3 text-sm" data-testid="date-from-input" />
        </div>
        <div>
          <Label htmlFor="accounting-date-to">Al</Label>
          <input id="accounting-date-to" type="date" min={`${fiscalYear}-01-01`} max={`${fiscalYear}-12-31`} value={dateTo} onChange={(e) => onDateTo(e.target.value)} className="mt-1 h-9 w-full rounded-md border bg-white px-3 text-sm" data-testid="date-to-input" />
        </div>
        <div className="flex gap-1.5 flex-wrap xl:justify-end">
          <Button type="button" size="sm" variant="outline" onClick={() => { const current = String(new Date().getFullYear()) === String(fiscalYear); onDateFrom(current ? monthStart : `${fiscalYear}-01-01`); onDateTo(current ? today : `${fiscalYear}-12-31`); }} data-testid="date-range-current-month">{String(new Date().getFullYear()) === String(fiscalYear) ? 'Mese' : 'Anno'}</Button>
          <Button type="button" size="sm" variant="outline" onClick={onSync} disabled={loading || accountId === 'all'} data-testid="btn-sync-hwsmart"><RefreshCw className="h-4 w-4" /></Button>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-2 border-t pt-3">
        <Button type="button" size="sm" onClick={onImport} disabled={accountId === 'all'} data-testid="btn-import-bank-statement"><FileUp className="h-4 w-4 mr-1.5" />Importa estratto conto</Button>
        <Button type="button" size="sm" variant="outline" onClick={onManual} disabled={accountId === 'all'} data-testid="btn-manual-transaction-entry"><Plus className="h-4 w-4 mr-1.5" />Movimento manuale</Button>
        <Button type="button" size="sm" variant="outline" onClick={onCloseMonth} data-testid="btn-open-month-closure"><CalendarCheck className="h-4 w-4 mr-1.5" />Chiusura mese</Button>
        <Button type="button" size="sm" variant="outline" onClick={onAi} data-testid="btn-open-ai-copilot"><Bot className="h-4 w-4 mr-1.5" />Analizza con AI</Button>
        {accountId === 'all' && <span className="text-xs text-amber-700 self-center" data-testid="account-required-alert">Seleziona un conto per importare o sincronizzare.</span>}
      </div>
    </Card>
  );
};